window.addEventListener('DOMContentLoaded', () => {
  initFoldableContents();
})

function initFoldableContents() {
  // Select all footer items that have a heading (p element) and a link list
  document.querySelectorAll('.leny-azantic-footer__link-list').forEach(item => {
    // Get the heading element (p) which will be the clickable toggle
    const heading = item.querySelector('p');
    
    // Add click event only to the heading, not the entire item
    heading.addEventListener('click', function(e) {
      // Prevent event from bubbling up
      e.stopPropagation();
      
      const childLinkList = item.querySelector('.link-list__links');
      const arrow = item.querySelector('.link-list__arrow');
      
      const isOpen = childLinkList.getAttribute('data-toggle') === 'open';
      
      // Close all other link lists
      document.querySelectorAll('.link-list__links').forEach(linkList => {
        linkList.setAttribute('data-toggle', 'close');
      });

      // Reset all arrows
      document.querySelectorAll('.link-list__arrow').forEach(linkArrow => {
        linkArrow.setAttribute('data-toggle', 'open');
      });
      
      // Toggle the current link list
      if (!isOpen) {
        childLinkList.setAttribute('data-toggle', 'open');
        arrow.setAttribute('data-toggle', 'close');
      }
    });
  });
}
  